import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { TOKEN_ALLOWLIST, MINT_PAGES_ENABLED, IS_SOL_ONLY_LAUNCH } from './config/launch';

// Vite bakes these in at build time, so a bad build arg is otherwise invisible
// from outside — you get the fallback and no sign that you asked for anything
// else. Print what actually shipped.
console.info(
  '[launch] tokens=%s mintPages=%s%s',
  TOKEN_ALLOWLIST === 'all' ? '* (bridge contract decides)' : TOKEN_ALLOWLIST.join(','),
  MINT_PAGES_ENABLED ? 'on' : 'off',
  IS_SOL_ONLY_LAUNCH ? ' (SOL-only launch)' : '',
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
